import { duration } from '@mui/material';
import axios from 'axios';

const API_BASE_URL = 'https://getmentors.globaleducationtalent.com/backend/'; // Replace with your API base URL

const apiService = axios.create({
    baseURL: API_BASE_URL,
});
apiService.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token'); // or get it from context
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);
export const getMentorData = async (data,is_active) => {
    try {
        const response = await apiService.post(`api/mentor/list`, {
            country_studied_in: data || null,
            is_active:is_active|| null
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};
export const MentorStatusUpdate = async ({ids}) => {
    try {
        const response = await apiService.post(`api/mentor/mentorstatus/update`, {
            id: ids || null,
            is_active:true
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};
export const deleteMentorData = async (id, token) => {

    try {
        const response = await apiService.post(`api/mentor/delete/${id}`, {

        })

        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};
export const login = async (data, password) => {

    try {
        const response = await apiService.post(`api/auth/login`, {
            email: data.email,
            password: password ?? data.password,
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};
export const register = async (data) => {
    // console.log("data",data)
    try {
        const response = await apiService.post(`api/auth/register`, {
            email: data.email,
            password: data.password,
            first_name: data.first_name,
            last_name: data.last_name,
            dob: data.dob,
            mobile: data.mobile,
            area_of_study: data.area_of_study,
            college: data.college,
            expertise: data.expertise,
            langauge_spoken1: data.language_spoken1,
            langauge_spoken2: data.language_spoken2,
            about: data.about,
            country_studied_in: data.country_studied_in,
            role_id: data.role_id
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};
export const query = async (data) => {
    // console.log("data",data)
    try {
        const response = await apiService.post(`api/query/send`, {
            email: data.email,
            name: data.name,
            message: data.message,
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};

export const addMentor = async (formData) => {
    try {
        const response = await apiService.post(`api/mentor/create`, formData);
        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};
export const editMentor = async (id, formData) => {
    try {
        formData.append("id", id); // add ID to FormData
        const response = await apiService.post(`api/mentor/edit`, formData);
        return response.data;
    } catch (error) {
        console.error("Error updating mentor data:", error);
        throw error;
    }
};

export const getMentorStudentData = async (id, name) => {
    name = name || null;
    try {
        const payload =
            name === "student"
                ? { refuserid: id }
                : { refmentorid: id };
        const response = await apiService.post(`api/mentor/Mentor-Student/list`, payload);
        return response.data;
    } catch (error) {
        // console.error("Error fetching mentor data:", error);
        throw error;
    }
};
export const uploadProfileImage = async (payload) => {
    try {
        const response = await apiService.post(`api/user/upload-profile`, payload);
        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};
export const UpdateStatusStudentData = async (id, bool) => {
    try {
        const response = await apiService.post(`api/mentor/IsAccepted/update`, {
            meeting_id: id,
            isaccepted: bool
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};

export const addMentorPrice = async (formData) => {
    try {
        const response = await apiService.post(`api/MentorPrice/create`, formData);
        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};

export const editMentorPrice = async (formData) => {
    try {
        const response = await apiService.post(`api/MentorPrice/edit`, formData);
        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};
export const sendotp = async (data) => {

    try {
        const response = await apiService.post(`api/auth/register/send-otp`, {
            email: data.email,
            is_new: data.is_new
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};
export const verifyotp = async (data) => {
    // console.log("data",data)
    try {
        const response = await apiService.post(`api/auth/register/verify-otp`, {
            email: data.email,
            otp: data.otp
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};
export const resetpassword = async (otp) => {

    try {
        const response = await apiService.post(`api/auth/password/forgot`, {
            otp: otp.otp,
            password: otp.password
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};
export const verifypasswordotp = async (email, otp) => {

    try {
        const response = await apiService.post(`api/auth/password/otp/verify`, {
            email: email,
            otp: otp
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};
export const sendpasswordotp = async (data) => {

    try {
        const response = await apiService.post(`api/auth/password/send/otp`, {
            email: data,
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};
export const GetTimeSlot = async (id, date, timepayload, bookedstatus, stdate, enddate) => {
    try {
        const payload = {
            refmentorid: id,
            // mode: "vedio",
            // price: "25",
            // duration: "60",
            is_booked: bookedstatus,
        };

        // Conditionally add either `date` or `start_date` + `end_date`
        if (date) {
            payload.date = date;
        } else {
            payload.start_date = stdate;
            payload.end_date = enddate;
        }

        const response = await apiService.post(`api/mentor/timeslot/list`, payload);
        return response;
        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};
export const CreateMeeting = async (payload) => {
    try {
        const response = await apiService.post(`api/mentor/Meeting/send`, payload);
        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};

export const RequestMeeting = async (payload) => {
    try {
        const response = await apiService.post(`api/mentor/Request/time`, payload);
        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};
export const GetPrice = async (mentorid) => {
    try {
        const response = await apiService.post(`api/MentorPrice/list`, {
            mentor_id: mentorid.toString(),
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};
export const GetPriceDrawer = async (mentorid) => {
    try {
        const response = await apiService.post(`api/MentorPriceList/list`, {
            mentor_id: mentorid.toString(),
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};
export const getMentorTimeSlot = async (mentorId, date) => {

    try {
        const response = await apiService.post(`api/mentor/timeslot/list`, {
            refmentorid: mentorId,
            date: date,
            // is_booked: null
        });
        return response?.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};
export const addMentorTimeSlot = async (formData) => {
    console.log("formData", formData);

    try {
        const response = await apiService.post(`api/mentor/AddTimeslots`, formData);
        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};
export const getCountryData = async () => {
    try {
        const response = await apiService.post(`api/mentor/country-list`);
        return response.data;
    } catch (error) {
        console.error("Error fetching mentor data:", error);
        throw error;
    }
};